import { format } from 'date-fns';
import React, { Component, type ReactElement } from 'react';
import { CameraFavoriteToggler } from './CameraFavoriteToggler';
import type { CameraInfoProps } from './Cameras.types';

export class CameraInfo extends Component<CameraInfoProps> {
    render(): ReactElement {
        return (
            <div className={'camera-info d-flex mt-1 ' + (this.props.showUpdateTime ? 'justify-content-between' : 'justify-content-end')}>
                {this.props.showUpdateTime && (
                    <span className="camera-info__time-stamp">Bilden hämtades {format(this.props.updatedTime || new Date(), 'HH.mm')}</span>
                )}
                <CameraFavoriteToggler pageId={this.props.cameraPageId} region={this.props.region} />
            </div>
        );
    }
}

export default CameraInfo;
